<template>
  <section class="software-download has-text-centered box">
    <div class="file-return-topics">
      <router-link to="/software"><h4 class="is-size-6">Back to Topics</h4></router-link>
    </div>
    <div class="file-download-info">
      <div v-if="errorMessage">
        <font-awesome-icon :icon="['far', 'exclamation-triangle']" class="has-text-danger" size="3x" />
        <h4>File not found</h4>
        <p>{{errorMessage}}</p>
      </div>
      <div v-else>
        <div v-if="isDownloading">
          <div class="spinner-container">
            <spinner-loader></spinner-loader>
          </div>
          <h4>Acquiring file info:</h4>
          <span class="tag is-medium is-light">{{normalizeFileName(fileName)}}</span>
        </div>
        <div v-else class="download-success">
          <font-awesome-icon :icon="['far', 'check-square']" class="has-text-success" size="3x" />
          <h4>Opening file:</h4>
          <span class="tag is-medium is-light">{{normalizeFileName(fileName)}}</span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { onMounted, ref, getCurrentInstance } from 'vue';
import SpinnerLoader from '../shared/SpinnerLoaderComponent.vue';

export default {
  components: {
    'spinner-loader': SpinnerLoader
  },
  setup() {
    const app = getCurrentInstance();
    const root = app.proxy.$root;
    const fileName = ref('');
    const isDownloading = ref(true);
    const errorMessage = ref('');

    const download = async (path, nameOfFile, view) => {
      // fetch the direct URL of the file in File Storage using SAS token
      const fileResult = await root.$store.dispatch('downloadStorageFile', { container: 'software-downloads', absolutePath: path, view: view || false });
      if (!fileResult) {
        errorMessage.value = 'The resource you are looking for might have been removed, or is temporarily unavailable.';
        isDownloading.value = false;
        return;
      }

      // if the file is a PDF, open the PDF inline in the users' browser (new tab)
      if (view && fileResult && fileResult.includes('.pdf')) {
        const a = document.createElement('a');
        a.download = nameOfFile;
        a.target = '_blank';
        a.href = `${fileResult}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        // not a PDF, just download the file
        // eslint-disable-next-line no-restricted-globals
        location = fileResult;
      }

      // stop the spinner
      isDownloading.value = false;
      // KyAnalytics client plugin, event tracker
      root.$kya.event('software', 'downloadStorageFile', 'Storage file downloaded', { file: nameOfFile });
    };

    const normalizeFileName = (value) => {
      // sanity check
      if (!value) return '-';

      // split the value on hyphen
      const titleSplit = value.split('-');
      const fileId = titleSplit.slice(0, 4).join('-');
      const regex = RegExp(/(\d{3}-\d{5}-\d{3}-rev(\d{1,2}|\w{1,2}))/, 'gi');
      let isTechFile = false;

      // check if we're looking at tech file or not
      if (regex.test(fileId)) {
        isTechFile = true;
      }
      // file name format not recognized, just return the value
      if (!isTechFile) return value;
      // this may be impossible but just in case
      if (titleSplit.length == 0) return value;
      // remove the first 4 items
      titleSplit.splice(0, 4);
      // re-join with spaces
      const title = titleSplit.join(' ');
      // now split on . and remove last part
      const titleParts = title.split('.');
      titleParts.pop();
      const returnResult = `${titleParts.join('.')} (${fileId})`
      return returnResult;
    };

    onMounted(() => {
      // acquire path from query
      const { path, view } = root.$route.query;
      // acquire filename from path
      if (path) fileName.value = path.split('/').pop();

      // do not continue if path or fileName are null
      if (!path) { errorMessage.value = 'Invalid path.'; return; }
      if (!fileName.value) { errorMessage.value = 'Invalid file name.'; return; }

      // initiate file download
      download(path, fileName.value, view);  
    });

    return {
      fileName,
      isDownloading,
      errorMessage,
      download,
      normalizeFileName
    }
  }
}
</script>
<style lang="scss" scoped>
.software-download {
  height: 500px;
  margin-top: 25px;
  padding: 10px 20px;

  .file-return-topics {
    display: flex;
    justify-content: flex-end;
  }
  .file-download-info {
    margin-top: -45px;
    height: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  svg {
    margin-bottom: 20px;
  }
  .spinner-container {
    margin-bottom: 20px;
  }
  h4 {
    margin-bottom: 15px;
  }
}
</style>
